import { PaginationMetadata } from "../../Types";
import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { getRelatedTradeProposals, url as relatedTradeProposalsUrl, } from "../request/getRelatedTradeProposals";
import { TradeProposalId } from "../types";
export { PaginationMetadata, TradeProposalId };
export function keyMaker(tradeProposalId, queryParams) {
    return [relatedTradeProposalsUrl(tradeProposalId, queryParams)];
}
const useRelatedTradeProposals = makeDoubleArgHook(getRelatedTradeProposals, keyMaker);
export default useRelatedTradeProposals;
//# sourceMappingURL=useRelatedTradeProposals.js.map